import { createContext } from 'react';

const TextEditor = createContext(null);

export { TextEditor };

export default TextEditor;
